import React from "react";
import {
    DialogTitle as MuiDialogTitle,
    DialogContent as MuiDialogContent,
    DialogActions as MuiDialogActions,
    IconButton,
    makeStyles,
    withStyles,
} from "@material-ui/core";
import { defineMessages } from "react-intl";
import CloseIcon from "@material-ui/icons/Close";

export const labels = defineMessages({
    close: {
        id: "admin.work-order-details.close",
        defaultMessage: "Close",
        description: "Admin work order close text",
    },
    open: {
        id: "admin.work-order-details.open",
        defaultMessage: "Open",
        description: "Admin work order open",
    },
    noOptions: {
        id: "admin.work-order-details.no-options",
        defaultMessage: "No options",
        description: "Admin work order no options",
    },
});
export const messages = defineMessages({
    completionCodeTitle: {
        id: "task-completion-form.header-title",
        defaultMessage: "Completion Code",
        description: "Completion task form title",
    },
    completionCodeSubtitle: {
        id: "task-completion-dialog.subtitle",
        defaultMessage: "Reason for completion",
        description: "Completion Code dialog subtitle",
    },
    requestComments: {
        id: "incomplete-dialog.incomplete-comment-field",
        defaultMessage: "Add your comments here",
        description: "submit incomplete job comments",
    },
    addFollowUpMandatory: {
        id: "admin.work-order-details.follow-up-list.add-follow-up-mandatory",
        defaultMessage: "Follow-ups",
        description: "Add Follow-up title",
    },
    addFollowUpTitle: {
        id: "wo-actions.follow-ups.title",
        defaultMessage: "Follow-Up",
        description: "Follow-ups popup title",
    },
    completionDateTitle: {
        id: "admin.workorder-details.completeDate",
        defaultMessage: "Completion Date",
        description: "Completion Date dialog subtitle",
    },
});

export const useStyles = makeStyles((theme) => ({
    root: {
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
    paper: {
        borderRadius: "0.9rem",
        top: 25,
        maxHeight: "calc(100% - 100px)",
        minWidth: 540,
        [theme.breakpoints.down("sm")]: {
            minWidth: 450,
        },
        [theme.breakpoints.down("xs")]: {
            minWidth: 350,
        },
    },
    confirmButton: {
        backgroundColor: "var(--blue-bell)",
        color: "var(--text-white)",
        padding: "0.5rem 2rem",
        borderRadius: "0.5rem",
        "&:hover": {
            backgroundColor: "var(--blue-bell)",
            color: "var(--text-white)",
        },
    },
    confirmDisabledButton: {
        backgroundColor: "var(--disabled-color)",
        padding: "0.5rem 2rem",
        borderRadius: "0.5rem",
        "&.Mui-disabled": {
            color: "var(--inactive-color)",
        },
    },
    characterCount: {
        fontSize: "0.6rem",
        color: "#999999",
        position: "absolute",
        bottom: "0.1rem",
        right: "0.3rem",
    },
    dropDown: {
        margin: "0 0 1rem",
    },
    commentSection: {
        position: "relative",
    },
    followupSection: {
        padding: "1rem",
    },
    cardPadding: {
        padding: "0.8rem 0",
    },
    followupsheader: {
        color: "var(--text-medium)",
        fontFamily: "Arial",
        fontSize: "1rem",
        padding: "0 0 0.5rem 0",
    },
    addfollowUp: {
        borderRadius: "0.3rem",
        border: "1px solid #00549A",
    },
    followupCard: {
        border: " 1px solid #E1E1E1",
        margin: "1rem 0",
        borderRadius: "0.8rem",
    },
    followupCardHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "2rem",
        padding: "0.4rem 1rem",
        background: "#E1E1E1",
        borderRadius: "0.7rem 0.7rem 0 0",
    },
    deleteButton: {
        padding: 0,
    },
    addfollowUpBtn: {
        color: "var(--blue-bell)",
        padding: "0.4rem 0.6rem",
    },
}));

export const styles = (theme) => ({
    title: {
        backgroundColor: "var(--blue-bell)",
        padding: "0.8rem 1rem",
        fontFamily: "BellSlimBlack",
        fontSize: "1.1rem",
        color: "var(--text-white)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    closeButton: {
        padding: 0,
    },
});

export const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.title} {...other}>
            <div>{children}</div>
            {onClose ? (
                <IconButton aria-label="close" color="inherit" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon title="Close Dialog" />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

export const DialogContent = withStyles((theme) => ({
    root: {
        padding: "1rem 1.5rem 0rem",
    },
}))(MuiDialogContent);

export const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: "1rem 1.5rem",
    },
}))(MuiDialogActions);
